import classNames from 'classnames';
import * as React from 'react';

import { AppFormField, AppFormFieldOwnProps, AppFormFieldProps } from 'components/form/appFormField';
import { domainPrefixValidator, required } from 'components/form/formValidations';
import styles from './DomainField.module.scss';

class Field extends AppFormField {
  protected renderInput(field: AppFormFieldProps): JSX.Element {
    return (
      <div className={classNames('input-group', styles.wrapper)}>
        <div className="input-group-prepend">
          <span className="input-group-text">{process.env.REACT_APP_PORTALS_PROTOCOL}://</span>
        </div>
        <input
          {...field.input}
          className={classNames({ invalid: this.isFieldInvalid(field) }, 'text-input', 'form-control')}
          type="text"
        />
        <div className="input-group-append">
          <span className="input-group-text">{`.${process.env.REACT_APP_PORTALS_DOMAIN}`}</span>
        </div>
      </div>
    );
  }
}

const validator = domainPrefixValidator(process.env.REACT_APP_PORTALS_DOMAIN);

export const DomainField = (props: AppFormFieldOwnProps) => <Field {...props} validate={[required, validator]} />;
